import { Modal, Typography } from 'antd';

import { Button } from '@shared/components';

const { Text } = Typography;

interface CustomFileInputOptionsProps {
  cancelText: string;
  handleCancel: () => void;
  handleRemovePhoto: () => void;
  handleReplacePhoto: () => void;
  isShowOptionsModal: boolean;
  onCancel: () => void;
  removeText: string;
  replaceText: string;
  title: string;
}
const CustomFileInputOptionsModal = ({
  cancelText,
  handleCancel,
  handleRemovePhoto,
  handleReplacePhoto,
  isShowOptionsModal,
  onCancel,
  removeText,
  replaceText,
  title,
}: CustomFileInputOptionsProps) => (
  <Modal centered closable={false} footer={null} maskClosable={false} onCancel={onCancel} open={isShowOptionsModal}>
    <div className="mx-auto flex w-3/4 flex-col items-center justify-center py-4">
      <Text className="gbmask text-base font-semibold">{title}</Text>
      <div className="mt-3 flex w-full flex-col gap-5">
        <Button className="json-checked w-full" onClick={handleReplacePhoto} variant="secondary">
          {replaceText}
        </Button>
        <Button className="json-checked w-full" onClick={handleRemovePhoto} variant="secondary">
          {removeText}
        </Button>
        <Button className="json-checked w-full" onClick={handleCancel} variant="secondary">
          {cancelText}
        </Button>
      </div>
    </div>
  </Modal>
);

export default CustomFileInputOptionsModal;
